var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "activities-tab-navbar",
        [
          _c(
            "v-btn",
            {
              attrs: {
                "x-small": "",
                text: "",
                icon: "",
                color: "accent",
                disabled: _vm.task.content && _vm.task.content.length <= 0
              },
              on: { click: _vm.exitTabDetails }
            },
            [_c("v-icon", [_vm._v("arrow_back_ios")])],
            1
          ),
          _vm._v(" "),
          _c("v-flex", { staticClass: "subheading font-weight-bold" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$tc("Task", 1)) +
                " " +
                _vm._s(_vm.task.title) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("toggle-buttons", {
            staticStyle: { margin: "6px 8px" },
            attrs: { buttons: _vm.toggleButtons },
            model: {
              value: _vm.mode,
              callback: function($$v) {
                _vm.mode = $$v
              },
              expression: "mode"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading && _vm.mode === "details"
        ? _c("task-form", {
            attrs: {
              task: _vm.task,
              "action-type": _vm.actionType,
              activityUUID: this.activityUUID,
              width: _vm.width
            },
            on: { update: _vm.getTask, delete: _vm.exitTabDetails }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            {
              staticStyle: {
                position: "relative",
                width: "100%",
                height: "100px"
              }
            },
            [
              _c("loading-spinner", {
                attrs: {
                  active: _vm.loading,
                  "is-full-page": false,
                  color: "accent",
                  "background-color": "transparent"
                },
                on: {
                  "update:active": function($event) {
                    _vm.loading = $event
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70033920", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70033920","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/TaskDetails/TaskDetails.vue
// module id = null
// module chunks = 